import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import React, { useEffect, useRef, useState } from 'react'
import { AiOutlineClose } from 'react-icons/ai'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store/modules/rootReducer'
import { editStudentIdentification } from '../../store/modules/student/actions'
import * as Yup from 'yup'
import getValidationError from '../../utils/getValidationErrors'
import Input from '../Input'

import {
  Container,
  Content,
  ButtonClose,
  TitleIdent,
  TableForOptions,
  InputTextOther,
  Option,
  Conclude,
  Wrapper,
} from './styles'

interface ModalProps {
  onClose(): void
  open: boolean
}

const ModalIdentification: React.FC<ModalProps> = ({ onClose, open }) => {
  const { profile } = useSelector((state: RootState) => state.student)
  const formRef = useRef<FormHandles>()
  const [loading, setLoading] = useState(false)
  const [radio, setRadio] = useState('')
  const [disableModal, setDisableModal] = useState<boolean>(false)
  const [disableTextInput, setDisableTextInput] = useState<boolean>()
  const [disableButton, setDisableButton] = useState<boolean>()
  const [showErrorInput, setShowErrorInput] = useState<boolean>(false)
  const dispatch = useDispatch()

  const checked = useRef(null)
  const isRadioSelected = (value: string): boolean => radio === value
  useEffect(() => {
    if (radio === '') {
      setDisableButton(true)
    } else {
      setDisableButton(false)
    }

    if (radio !== 'checkboxRadio') {
      setDisableTextInput(true)
    } else {
      setDisableTextInput(false)
    }

    if (disableModal === true) {
      setDisableButton(false)
    }
  }, [disableModal, radio])

  const showButton = () => {
    setDisableModal(!disableModal)
  }

  const handleSubmit = async (data, { reset }) => {
    if (checked.current.checked === true) {
      data.showHowKnow = false
    } else {
      data.showHowKnow = checked.current.checked
    }
    try {
      setLoading(true)
      formRef.current?.setErrors({})

      if (radio === 'checkboxRadio') {
        data.howKnow = data.other
      } else {
        data.howKnow = radio
      }

      if (radio === 'checkboxRadio') {
        const schema = Yup.object().shape({
          other: Yup.string().min(2),
        })

        await schema.validate(data, {
          abortEarly: false,
        })
      }

      dispatch(
        editStudentIdentification({
          ...profile,
          howKnow: data.howKnow,
          showHowKnow: data.showHowKnow,
        })
      )

      setLoading(false)
      reset()
    } catch (err) {
      setLoading(false)
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationError(err)
        if (errors.other === 'other must be at least 2 characters') {
          setShowErrorInput(true)
        }
      }
      console.error(err)
    }
  }

  const closeModal = () => {
    onClose()
    dispatch(editStudentIdentification({ ...profile, showHowKnow: false }))
  }

  useEffect(() => {
    window.onclick = function (event: any) {
      if (event.target.id === 'close') onClose()
    }
  }, [dispatch, onClose, profile])

  return (
    <Container open={open} id="close">
      <Content>
        <Wrapper>
          <ButtonClose type="button" id="closeButton" onClick={() => closeModal()}>
            <AiOutlineClose id="closeButton" size={30} />
          </ButtonClose>
        </Wrapper>
        <TitleIdent>
          <h1>Descreva como nos conheceu</h1>
        </TitleIdent>
        <Form ref={formRef} onSubmit={handleSubmit} autoComplete="false">
          <TableForOptions>
            <Option>
              <input
                type="radio"
                name="news"
                value="news"
                checked={isRadioSelected('news')}
                onChange={(e) => setRadio(e.target.value)}
              />
              <label htmlFor="news">Conheci por uma notícia</label>
            </Option>
            <Option>
              <input
                type="radio"
                name="google"
                value="google"
                checked={isRadioSelected('google')}
                onChange={(e) => setRadio(e.target.value)}
              />
              <label htmlFor="google">Pesquisando sobre concursos no Google</label>
            </Option>
            <Option>
              <input
                type="radio"
                name="friendOrRelative"
                value="friendOrRelative"
                checked={isRadioSelected('friendOrRelative')}
                onChange={(e) => setRadio(e.target.value)}
              />
              <label htmlFor="friendOrRelative">Indicação de um amigo/parente</label>
            </Option>
            <Option>
              <input
                type="radio"
                name="youtubeLesson"
                value="youtubeLesson"
                checked={isRadioSelected('youtubeLesson')}
                onChange={(e) => setRadio(e.target.value)}
              />
              <label htmlFor="youtubeLesson">Vi uma aula gratuita do Direção no YouTube</label>
            </Option>
            <Option>
              <input
                type="radio"
                name="socialMedia"
                value="socialMedia"
                checked={isRadioSelected('socialMedia')}
                onChange={(e) => setRadio(e.target.value)}
              />
              <label htmlFor="socialMedia">
                Anúncio em redes sociais (Instagram, Facebook, etc)
              </label>
            </Option>
            <Option>
              <input
                type="radio"
                name="checkboxRadio"
                value="checkboxRadio"
                checked={isRadioSelected('checkboxRadio')}
                onChange={(e) => setRadio(e.target.value)}
              />
              <div className="inputModal">
                <Input
                  type="text"
                  disabled={disableTextInput}
                  name="other"
                  id="other"
                  size={80}
                  placeholder="Outras formas"
                />
                <div className="errorInput">
                  <small>
                    {showErrorInput ? 'Ajude-nos a saber como você chegou até nós' : ''}
                  </small>
                </div>
              </div>
            </Option>
          </TableForOptions>
          <InputTextOther>
            <input
              type="checkbox"
              name="showHowKnow"
              ref={checked}
              checked={disableModal}
              onClick={() => {
                showButton()
              }}
              onChange={showButton}
            />
            <label htmlFor="showHowKnow">Não exibir esta mensagem novamente</label>
          </InputTextOther>
          <Conclude disabledClonclude={disableButton}>
            <button disabled={disableButton} type="submit">
              {loading ? 'Enviando...' : 'Concluir'}
            </button>
          </Conclude>
        </Form>
      </Content>
    </Container>
  )
}

export default ModalIdentification
